import { useRouter, useRoute } from 'vue-router'
import { onMounted } from 'vue'
import { statusCheck } from '../api'

const stageRouteMap = {
  MOBILE_VERIFIED: 'pii',
  PII_SUBMITTED: 'done',
}

export async function getNextRoute() {
  const { data } = await statusCheck()
  let nextRouteName = stageRouteMap[data.status]
  if (!nextRouteName) {
    nextRouteName = 'done'
  }
  return nextRouteName
}
